import { EdlTemplateTypeDTO } from '@edl-development/edl-common';
import { CplItem } from './cpl-item.model';

export class CplItemDuplicateData{
    ItemModel: CplItem;
    Title: string;
    ShouldDuplicateRoster: boolean;
    ShouldDupItemPackets: boolean;
    QfmId: string;
    QfmTitle: string;
    EdlTemplateTypes: EdlTemplateTypeDTO[];
}